import axios from "axios";
import { getCloudFunctionUrl } from "../utils/functions";
import { getAuthHeaders } from "../utils/authHeaders";

const cloudFunctionUrl = getCloudFunctionUrl();

/**
 * Attach an existing live Stripe customer (same email) to this Firebase uid.
 * Idempotent. Stripe keeps auto-billing; this only reconnects app access.
 */
export const linkExistingStripeSubscription = async () => {
  const headers = await getAuthHeaders();
  const { data } = await axios({
    method: "post",
    url: `${cloudFunctionUrl}/linkExistingStripeSubscription`,
    headers,
    data: {},
  });
  return data;
};
